import { useEffect, useRef, useState } from 'react';
import { useGateOutsQuery } from '../../hooks/use-query/gate-outs';
import { useIsVisible } from '../../hooks';
import {
  DashboardHeader,
  DashboardTable,
  DashboardTableCell,
  DashboardTableHeader,
  DashboardTableRow,
  DashboardTableRowLoading,
  DashboardTableRows,
  DashboardWrapper,
} from '../dashboard';
import { Typography } from '../../design-system';
import { formatContainerType } from '../../utils';
import { GateOutsCreateByFilter } from './GateOutsCreateByFilter';

export const GateOutsFilters = () => {
  const [isOpenFormPopup, setIsOpenFormPopup] = useState(false);
  const [isVisibleLoading, loadingRef] = useIsVisible();
  const selectedRow = useRef<any>({});

  const {
    data: { data, totalCount },
    isSuccess,
    refetch,
    isFetched,
    fetchNextPage,
    isFetching,
  } = useGateOutsQuery({
    onlyFilters: true,
    statusFilter: 'LOADING_ALLOWED',
  });

  useEffect(() => {
    if (!isVisibleLoading || isFetching) return;

    fetchNextPage();
  }, [isVisibleLoading]);

  const handleRowClick = (option: any) => {
    selectedRow.current = option;
    setIsOpenFormPopup(true);
  };

  const handleFormCloseClick = () => {
    setIsOpenFormPopup(false);
  };

  return (
    <DashboardWrapper rows={'4rem 1fr'}>
      <GateOutsCreateByFilter
        filter={selectedRow.current}
        isOpen={isOpenFormPopup}
        refetch={refetch}
        handleFormCloseClick={handleFormCloseClick}
      />
      <DashboardHeader>
        <Typography variant={'textXL'} weight={'bold'}>
          Gate Out by Filters: {totalCount}
        </Typography>
      </DashboardHeader>
      <DashboardTable>
        <DashboardTableHeader>
          <DashboardTableCell>Code</DashboardTableCell>
          <DashboardTableCell>Type</DashboardTableCell>
          <DashboardTableCell align={'right'}>Request Count</DashboardTableCell>
        </DashboardTableHeader>
        <DashboardTableRows>
          {isSuccess &&
            data.map((row: any, i: any) => (
              <DashboardTableRow key={i} onClick={() => handleRowClick(row)}>
                <DashboardTableCell>{row.clientYard.client.code}</DashboardTableCell>
                <DashboardTableCell>{formatContainerType(row.type)}</DashboardTableCell>
                <DashboardTableCell align={'right'}>{row.requestedCount}</DashboardTableCell>
              </DashboardTableRow>
            ))}
          {(!isFetched || data.length !== totalCount) && (
            <DashboardTableRowLoading key={data.length} setRef={loadingRef} />
          )}
        </DashboardTableRows>
      </DashboardTable>
    </DashboardWrapper>
  );
};
